import React from "react";
import {Col, Row} from "reactstrap";
import CopyToClipboard from "../../base/copy-to-clipboard";
import IconButton from "../../base/button/icon_button";
import {DialogActions, DialogContent, DialogTitle, SvgIcon} from "@mui/material";
import {ReactComponent as Copy} from "../../../../assets/images/copy.svg";
import Button from "../../base/button/button";
import Dialog from "../../base/dialog";

const OperatorResetPasswordModal = ({open, setOpen, operator, password}) => {

    return (
        <>
            <Dialog
                maxWidth={'sm'}
                open={open}
                setOpen={setOpen}
            >
                <DialogTitle className={'pb-0'}>
                    <Row xs={12} className='no-gutters justify-content-center w-100'>
                        <p className={`text-lg text-color-1 my-2 font-weight-semi-bold text-center`}>
                            New Password
                        </p>
                    </Row>
                </DialogTitle>
                <DialogContent dividers={true} className={'py-3'}>
                    <Row className='no-gutters justify-content-center align-items-center'>
                        <Col className={`mx-4 mt-3 mb-4`}>
                            <p className='text-start text-sm'>
                                {operator?.firstName ?? ''} {operator?.lastName ?? ''}'s password has been successfully
                                reset.
                            </p>
                        </Col>
                        <Col xs={12} className=' mb-5'>
                            <p className='text-sm text-color-1 mb-2 mx-4'>Operator's new password:</p>
                            <Row
                                className={`background-secondary-color-3 no-gutters align-items-center justify-content-between px-3 py-2 mx-4`}>
                                <p className='text-color-1 text-sm w-75'>
                                    {password ?? ""}
                                </p>
                                <CopyToClipboard>
                                    {({copy}) =>
                                        <IconButton
                                            onPressed={() => copy(password)}

                                            className={'copy-to-clipboard-button'}
                                        >
                                            <SvgIcon className={'icon normal'} component={Copy}/>
                                        </IconButton>}
                                </CopyToClipboard>

                            </Row>
                        </Col>
                        <div className='my-1 w-100'/>
                    </Row>
                </DialogContent>
                <DialogActions className={'d-flex align-items-center justify-content-between'} sx={{padding: 0}}>
                    <Button
                        variant={'dialog'}
                        color={'primary'}
                        onClick={() => setOpen(false)}
                        borderRadius={'0 8px 0 8px'}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default OperatorResetPasswordModal;
